import { VALIDATOR_PATTERN } from './validators';

export const validateSurname = (value: string) => {
  let surnameOne;
  let surnameTwo;
  const surnameArray = value.toString().match(/([^\s]+)/g);
  const originalSurnameArray = JSON.parse(JSON.stringify(surnameArray));
  for (let i = 0; i < originalSurnameArray.length; i++) {
    if (!surnameOne) {
      if (
        !VALIDATOR_PATTERN.FORBIDDEN_SURNAME_LIST.includes(
          originalSurnameArray[i].toUpperCase(),
        )
            && originalSurnameArray[i].length >= 2
      ) {
        surnameOne = surnameArray!.splice(0, i + 1);
        surnameOne = surnameOne.join(' ');
      }
    } else {
      surnameTwo = surnameArray;
      surnameTwo = surnameTwo!.join(' ');
    }
  }
  return { surnameOne, surnameTwo };
};
